<template>
<div class="pb-2 p-md-3 row">
  <div class="col-md-10">
    <div style="display: flex; flex-direction: row" class="justify-content-center pb-3">
      <VOtpInput
        ref="otpInput"
        value=""
        input-classes="otp-input"
        separator="-"
        :num-inputs="6"
        :should-auto-focus="true"
        input-type="letter-numeric"
        @on-complete="handleOnComplete"
      />
      </div>
         
  </div>  
  <div class="col-md-2">
    <button class="btn btn-secondary btn-sm" @click="clearInput"> <font-awesome-icon icon="broom" /> Clear</button>
  </div>    
 
</div>  
</template>

<script>
import VOtpInput from "vue3-otp-input";

export default {
  name: 'CodeEntry',
    components: {
   VOtpInput
  },

   setup(props, { emit }) {
    
    const handleOnComplete = (code) => {
      emit("verifyEvent", code);
    };

    return { handleOnComplete };
  },

  methods: {
    clearInput(){
      this.$refs.otpInput.clearInput();
    }
   }
}  



</script>
<style>
.otp-input {
  width: 40px;
  height: 40px;
  /*padding: 5px;
  margin: 0 10px;*/
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>